import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { HeroImage } from "../shared/hero-image";
import StoryCard from "../shared/story-card";
import Breadcrumb from "../shared/breadcrumbs";
import { humanizeDate } from "../../../../utils/time-format";
import { VikatanResponsiveContainer } from "../../../../rows/ad-free";
import StoryMidPromotion from "../../storyMidContent";
import styles from "../text-story-page/styles.m.css";
import stylesPA from "./styles.m.css";

function LiveBlogStory(props) {
  const renderSocialMedia = get(props, ["renderSocialMedia"], () => null);
  const renderFooter = get(props, ["renderFooter"], () => null);
  const renderSidebar = get(props, ["renderSidebar"], () => null);
  const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);
  const isClosed = get(props, ["story", "metadata", "is-closed"], false);
  const section = get(props, ["story", "sections", "0"], null);
  const storyHeadline = get(props, ["story", "subheadline"], () => null);
  const singleCard = get(props, ["story", "cards"], null);

  const readMore = false;
  const cards = readMore ? singleCard.slice(0, 1) : singleCard;

  return (
    <div className="page-content">
      <div className={`container`}>
        <Breadcrumb subSection={section} config={props.config} />
      </div>
      <div className={`container ${styles["story-grid"]}`}>
        <div className={styles["main-content"]}>
          <article className={`${styles["story-body"]} js-story`}>
            {renderHeaderCard()}
            <HeroImage story={props.story} className={styles["hero-image"]} icon="liveupdate" headline="Live Update" />
            {!readMore && renderSocialMedia()}
            <p className={`${styles["subheadline"]}`}>{storyHeadline}</p>
            {cards &&
              cards.map((card, index) => {
                return (
                  <div className={stylesPA["card-wrapper"]} key={card.id}>
                    <timestamp className={stylesPA["timestamp"]}>
                      {isClosed ? humanizeDate(card["card-added-at"], "absolute") : humanizeDate(card["card-added-at"])}
                    </timestamp>
                    {index === 1 && (
                      <div>
                        <StoryMidPromotion story={props.story} />
                      </div>
                    )}

                    <StoryCard card={card} story={props.story} showCard={readMore} />

                    <VikatanResponsiveContainer
                      placement={"text-story"}
                      adtype={parseInt(index + 1)}
                      story={props.story}
                      className="ad_300_250"
                    />
                  </div>
                );
              })}

            <div id="we-story-end" />
            {renderFooter(readMore)}
          </article>
        </div>
        {renderSidebar()}
      </div>
    </div>
  );
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,

  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any
});
LiveBlogStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func
};

export { LiveBlogStory };
